/**
 * hellopanda-onoff
 */
const HELLOPANDA_ONOFF = {
  init: function() {

    const _ = this;

    // 전역 객체 생성
    window.hellopanda = window.hellopanda || {} ;
    const setting = window.hellopanda.onoff;

    if (setting) {
      // 타이밍을 위해서 바로 실행
      // document.addEventListener('DOMContentLoaded', function() {
        const onoffs = document.querySelectorAll('.wp-block-hellopanda-onoff-block');
        onoffs.forEach(element => {

          let on = false;
          let rule_home = element.dataset.home;
          let rule_url = element.dataset.url || '' ;
          let rule_category = element.dataset.category || '' ;

          const urls = rule_url
          .replace(/\\n/g, '\n') // \n을 실제 줄바꿈으로 복원
          .split('\n')
          .map(url => url.trim())
          .filter(url => url);
        
          const categories = rule_category
          .replace(/\\n/g, '\n') // \n을 실제 줄바꿈으로 복원
          .split('\n')
          .map(category => category.trim())
          .filter(category => category);

          if (rule_home === 'true' && _.isRoot(setting.url)) {
            on = true;
          }
          if (urls.length) {
            const encodedUrls = urls.map(url => _.customEncodeURIComponent(url.replaceAll(' ', '-')));
            on = encodedUrls.some(encodedUrl => setting.url?.toLowerCase().includes(encodedUrl.toLowerCase()));
          }
          if (categories.length) {
            const encodedCategories = categories.map(category =>
              _.customEncodeURIComponent(category.replaceAll(' ', '-'))
            );
            if (encodedCategories.some(encodedCategory =>
              setting.category?.some(category =>
                category.toLowerCase().includes(encodedCategory.toLowerCase())
              )
            )) {
              on = true;
            }
          }

          // 예외처리 : 카테고리에 글이 없다면 카테고리가 빈값으로 오기 때문에 예외적으로 url 과 비교한다.
          if (!on && categories && !setting.category?.length && setting.url?.includes('/category/')) {
            const encodedEmptyCategories = categories.map(category => _.customEncodeURIComponent(category.replaceAll(' ', '-')));
            on = encodedEmptyCategories.some(encodedCategory => setting.url?.toLowerCase().includes(encodedCategory.toLowerCase()));
          }

          if (on) {
            element.setAttribute('data-onoff', 'on');
            _.moveScroll(element);
          }

        });
      // });
    }
  },
  moveScroll: function(me) {

    if (!(me instanceof HTMLElement)) return; // DOM 체크

    const parent = me.closest('.wp-block-group-is-layout-flex');
    if (!parent) return;

    // 가로 스크롤이 가능한 상태인지 확인
    if (parent.scrollWidth <= parent.clientWidth) return;

    const meLeft = me.offsetLeft;
    const meRight = meLeft + me.offsetWidth;

    const visibleLeft = parent.scrollLeft;
    const visibleRight = visibleLeft + parent.clientWidth;

    // 예외: 부모보다 자식이 더 큰 경우 → 그냥 왼쪽으로 정렬
    if (me.offsetWidth > parent.clientWidth) {
      parent.scrollTo({ left: meLeft, behavior: "smooth" });
      return;
    }

    // 왼쪽으로 벗어난 경우
    if (meLeft < visibleLeft) {
      parent.scrollTo({ left: meLeft, behavior: "smooth" });
    }
    // 오른쪽으로 벗어난 경우
    else if (meRight > visibleRight) {
      parent.scrollTo({ left: meRight - parent.clientWidth, behavior: "smooth" });
    }
    // 화면 안에 이미 있는 경우 → 아무 동작 안 함

  },
  isRoot: function() {

    const url = new URL(window.location.href);
      
    // URL의 경로가 빈 문자열이거나 '/'인지 확인
    const isRootPath = url.pathname === '' || url.pathname === '/';
    
    // 검색 파라미터와 해시가 비어 있는지 확인
    const hasNoSearchParams = !url.search || url.search === '?';
    const hasNoHash = !url.hash || url.hash === '#';
    
    // 모든 조건이 만족되면 true 반환
    return isRootPath && hasNoSearchParams && hasNoHash;

  },
  customEncodeURIComponent: function(url) {
    return url
    .split(/([:/=?])/g) // :, /, =, ? 문자를 유지하고 나머지를 분리
    .map(part => (part.match(/[:\/=?]/) ? part : encodeURIComponent(part))) // 유지할 문자와 나머지를 조건부로 처리
    .join('');
  }
};
HELLOPANDA_ONOFF.init();